import { createContext } from 'react';
import { ChecklistContextValue } from './types';

export const ChecklistContext = createContext<ChecklistContextValue>(
  {} as ChecklistContextValue
);
ChecklistContext.displayName = 'ChecklistContext';
